import React from 'react';
import { FileIcon } from 'elements/Icon';

const DOC = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z"/>
    <rect x="12.75" y="24" width="74" height="4"/>
    <rect x="12.75" y="36" width="74" height="4"/>
    <rect x="12.75" y="48" width="74" height="4"/>
    <rect x="12.75" y="60" width="74" height="4"/>
    <rect x="12.75" y="72" width="74" height="4"/>
    <rect x="12.75" y="84" width="54" height="4"/>
    <rect x="13.695" y="102.581" width="74" height="24"/>
    <g>
      <path fill="#FFFFFF" className="text" d="M31.547,118.018h2.367v2.336h-2.367V118.018z"/>
      <path fill="#FFFFFF" className="text" d="M42.959,109.088c0.808,0.266,1.462,0.753,1.962,1.461c0.401,0.573,0.675,1.192,0.821,1.859
        c0.146,0.667,0.219,1.302,0.219,1.906c0,1.531-0.308,2.828-0.923,3.891c-0.834,1.433-2.121,2.148-3.862,2.148h-4.965v-11.516h4.965
        C41.89,108.849,42.484,108.932,42.959,109.088z M38.547,110.838v7.516h2.223c1.137,0,1.93-0.56,2.378-1.68
        c0.245-0.614,0.368-1.347,0.368-2.195c0-1.172-0.184-2.071-0.552-2.699s-1.1-0.941-2.194-0.941L38.547,110.838L38.547,110.838z"/>
      <path fill="#FFFFFF" className="text" d="M56.633,119.331c-0.87,0.896-2.128,1.344-3.773,1.344s-2.903-0.448-3.773-1.344
        c-1.167-1.099-1.75-2.683-1.75-4.75c0-2.109,0.583-3.692,1.75-4.75c0.87-0.896,2.128-1.344,3.773-1.344s2.903,0.448,3.773,1.344
        c1.161,1.058,1.742,2.641,1.742,4.75C58.375,116.648,57.794,118.232,56.633,119.331z M55.129,117.581c0.56-0.703,0.84-1.703,0.84-3
        c0-1.292-0.28-2.29-0.84-2.996s-1.316-1.059-2.27-1.059s-1.714,0.352-2.281,1.055s-0.852,1.703-0.852,3s0.284,2.297,0.852,3
        s1.328,1.055,2.281,1.055S54.569,118.284,55.129,117.581z"/>
      <path fill="#FFFFFF" className="text" d="M61.311,110.042c0.928-0.948,2.107-1.422,3.54-1.422c1.917,0,3.318,0.636,4.205,1.906
        c0.489,0.714,0.752,1.43,0.788,2.148h-2.406c-0.153-0.552-0.35-0.969-0.59-1.25c-0.428-0.5-1.063-0.75-1.905-0.75
        c-0.857,0-1.533,0.353-2.028,1.059s-0.742,1.704-0.742,2.996s0.261,2.259,0.783,2.902s1.186,0.965,1.991,0.965
        c0.825,0,1.454-0.276,1.888-0.828c0.239-0.297,0.438-0.742,0.596-1.336h2.391c-0.206,1.255-0.733,2.276-1.58,3.062
        c-0.848,0.786-1.934,1.18-3.258,1.18c-1.639,0-2.927-0.531-3.865-1.594c-0.938-1.067-1.406-2.531-1.406-4.391
        C59.711,112.679,60.244,111.13,61.311,110.042z"/>
    </g>
  </FileIcon>
);

export default DOC;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/DOC.jsx